import React, {useEffect, useState} from 'react';
import Config from "../Config/Config";
import Group from "./ListComponent/Group";
import {useTranslation} from "react-i18next";

function List() {
    const {t} = useTranslation('common');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        fetch(Config.baseUrl + '/datapoint/list')
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`This is an HTTP error: The status is ${response.status}!`);
                }
                return response.json();
            })
            .then((data) => {
                setData(data.data);
                setLoading(false);
                setError(null);
            })
            .catch((err) => {
                setError(err.message);
                setData(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    if (loading) return <div>{t('please-wait')}</div>;

    if (error) return <div>{t('error')}</div>;

    return (
        <div className="list">
            <h1>{t('headline')}</h1>
            <h2>{t('overview')}</h2>

            {data.length &&
                <ul id="groups">
                    {data.map(({uid, title, pois}) => {
                        return <Group key={uid} uid={uid} title={title} pois={pois} />
                    })}
                </ul>
            }
        </div>
    )
}

export default List